'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {

  GLOBAL: {
    HIDE: '__react_tooltip_hide_event',
    REBUILD: '__react_tooltip_rebuild_event',
    SHOW: '__react_tooltip_show_event'
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/react-tooltip/dist/constant.js
// module id = 489
// module chunks = 0